import { IScanDocument } from 'shared/api/scan-document'

import { InsuranceParticipantData } from '../../../model/types'

type InsuranceScannedPersonData = Pick<
  IScanDocument,
  'last_name' | 'first_name' | 'date_of_birth' | 'id_card_number'
>

export const mergeScannedPersonData = <T extends InsuranceParticipantData>(
  currentPerson: T,
  scannedPerson: InsuranceScannedPersonData,
): T => ({
  ...currentPerson,
  ...(scannedPerson.last_name?.trim() && {
    lastName: scannedPerson.last_name,
  }),
  ...(scannedPerson.first_name?.trim() && {
    firstName: scannedPerson.first_name,
  }),
  ...(scannedPerson.date_of_birth?.trim() && {
    birthDate: scannedPerson.date_of_birth,
  }),
  ...(scannedPerson.id_card_number?.trim() && {
    passportNumber: scannedPerson.id_card_number,
  }),
})
